import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * A utility function to merge Tailwind CSS classes using clsx and tailwind-merge.
 * Resolves class conflicts (e.g., px-2 px-4 -> px-4).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
